import React from "react";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  noData: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 250,
  },
  noDataText: {
    fontSize: theme.textFontSize,
    lineHeight: "22px",
    padding: 4,
    border: `1px solid ${theme.TextColor}`,
    backgroundColor: theme.warningBGColor,
  },
});

const NoData = ({ classes, label }) => {
  return (
    <div className={classes.noData}>
      <div className={classes.noDataText}>{label}</div>
    </div>
  );
};
export default withStyles(styles)(NoData);
